import { PermissionTypeDto } from "clearline-api";

export const routePermissionsMap: Record<string, PermissionTypeDto> = {
  "/": PermissionTypeDto.Dashboard,
  "/dashboard": PermissionTypeDto.Dashboard,
  "/developers": PermissionTypeDto.Developers,
  "/manager/app-settings": PermissionTypeDto.MarketingTools,
  "/template": PermissionTypeDto.Templates,
  "/template/preview": PermissionTypeDto.Templates,
  "/template/preview-global": PermissionTypeDto.Templates,
  "/template/print": PermissionTypeDto.Templates,
  "/template/print-global": PermissionTypeDto.Templates,
  "/template/carousel-preview": PermissionTypeDto.Templates,
  "/manager/templates": PermissionTypeDto.Templates,
  "/manager/templates/add": PermissionTypeDto.Templates,
  "/manager/templates/edit": PermissionTypeDto.Templates,
  "/manager/locations/cfsterminals": PermissionTypeDto.CfsTerminals,
  "/manager/external-features/AdvancedMarketingTools": PermissionTypeDto.AdvancedTools,
  "/manager/short-urls": PermissionTypeDto.AppsShortUrlsAndQrs,
  "/manager/short-urls/apps": PermissionTypeDto.AppsShortUrlsAndQrs,
  "/manager/short-urls/custom": PermissionTypeDto.CustomShortUrlsAndQrs,
  "/manager/pixel-tags": PermissionTypeDto.TrackingPixel,
  "/manager/pixel-tags/new": PermissionTypeDto.TrackingPixel,
  "/manager/bulk-links": PermissionTypeDto.BulkLinksAndQrsList,
  "/manager/nfc-products": PermissionTypeDto.NfcProducts,
  "/manager/external-features/OutboundCampaigns": PermissionTypeDto.OutboundCampaigns,
  "/manager/pos-rules": PermissionTypeDto.PosRules,
  "/manager/pos-rules/add": PermissionTypeDto.PosRules,
  "/manager/pos-rules/edit": PermissionTypeDto.PosRules,
  "/manager/pos-activity-report": PermissionTypeDto.PosActivityReport,
  "/manager/imported-coupons": PermissionTypeDto.ImportedPromotions,
  "/manager/imported-transactions": PermissionTypeDto.ImportedTransactions,
  "/manager/pos-configuration": PermissionTypeDto.PosSettings,
  "/manager/pos-terminal-modes": PermissionTypeDto.TerminalOperationMode,
  "/manager/pos-marketplace": PermissionTypeDto.PosMarketplace,
  "/manager/pos-marketplace/pos-data-sync": PermissionTypeDto.PosMarketplace,
  "/manager/pos-receipt-settings": PermissionTypeDto.PosReceiptSettings,
  "/manager/pos-thank-you-page": PermissionTypeDto.PosThankYouPage,
  "/manager/pos-thank-you-page/edit": PermissionTypeDto.PosThankYouPage,
  "/manager/pricing-plan": PermissionTypeDto.PricingPlanUpgrade,
  "/manager/external-features/ReportingAnalytics": PermissionTypeDto.ThirdPartyAnalytics,
  "/manager/external-features/LoyaltyReporting": PermissionTypeDto.LoyaltyProgramReporting,
  "/manager/external-features/Contacts": PermissionTypeDto.ExternalContacts,
  "/manager/customers": PermissionTypeDto.Customers,
  "/manager/customers/customer-list": PermissionTypeDto.Customers,
  "/manager/customers/customer": PermissionTypeDto.Customers,
  "/manager/product/add": PermissionTypeDto.Products,
  "/manager/product/update": PermissionTypeDto.Products,
  "/manager/products/location": PermissionTypeDto.Products, // location-specific list: '/manager/products/location/{id}'
  "/manager/products/location/all": PermissionTypeDto.Products,
  "/manager/external-features/CustomTransactionReport": PermissionTypeDto.CustomTransactionReport,
  "/manager/settings": PermissionTypeDto.ManagerSettings,
  "/distributions": PermissionTypeDto.SmsMarketing,
  "/distributions/add": PermissionTypeDto.SmsMarketing,
  "/manager/locations": PermissionTypeDto.Locations,
  "/manager/locations/add": PermissionTypeDto.Locations,
  "/manager/devices": PermissionTypeDto.Devices,
  "/manager/users": PermissionTypeDto.Users,
  "/manager/users/add": PermissionTypeDto.Users,
  "/manager/users/modifyUser": PermissionTypeDto.Users,
  "/manager/my-brand": PermissionTypeDto.MyBrand,
  "/manager/external-feature": PermissionTypeDto.ExternalFeatureIframe,
  // "": PermissionTypeDto.PrintReceipts, // todo: tbd

  "/report/terminal-activity": PermissionTypeDto.Top20TerminalActivityChart,
  "/report/engagement-attempts": PermissionTypeDto.EngagementAttempts,
  "/report/top-sales-person": PermissionTypeDto.Top10SalesPersonsChart,
  "/report/smart-page-activities": PermissionTypeDto.SmartPageChart,
  "/report/app-activities": PermissionTypeDto.AppActivitiesChart,
  "/report/engagement-outcomes": PermissionTypeDto.TotalEngagementsChart,
  "/report/activities-by-location": PermissionTypeDto.ActivitiesByLocationsChart,
  "/report/short-links": PermissionTypeDto.ShortLinksChart
};
